const APP_BASE_URL = process.env.REACT_APP_API_URL;
// #DASHBOARD
const DASHBOARD_FETCH =   `${APP_BASE_URL}api/dashboard`

// #AUTH
const LOGIN = `${APP_BASE_URL}api/user/login`

// #ADD PRODUCT OR SUPPORTING PRODUCT
const ADD_PRODUCT = `${APP_BASE_URL}api/product/add`


// #FETCH PRODUCT OR SUPPORTING PRODUCT
const GET_ALL_PRODUCT = `${APP_BASE_URL}api/product/fetch`
// #PRODUCT
const CHANGE_PRODUCT_STATUS = `${APP_BASE_URL}api/product/status`
const GET_SINGLE_PRODUCT_DETAILS = `${APP_BASE_URL}api/product/details/fetch`
const PRODUCT_RELATED_DETAILS = `${APP_BASE_URL}api/product/search`

// #GET ACTIVE PRODUCTS OR SUPPORTING PRODUCT 
const GET_ALL_ACTIVE_PRODUCTS_OR_SUB_PRODUCTS = `${APP_BASE_URL}api/product/sub-products/active/get`

// #SUPPORTING PRODUCT 
const ADD_SUB_PRODUCT = `${APP_BASE_URL}api/product/sub-product/add`
const GET_ALL_SUB_PRODUCT = `${APP_BASE_URL}api/product/sub-products/get`

const GET_PRODUCT_RELATE_SUB_PRODUCTS = `${APP_BASE_URL}api/product/sub-products`
const CHANGE_SUB_PRODUCT_STATUS = `${APP_BASE_URL}api/product/sub-product/status`
const GET_ACTIVE_PRODUCTS = `${APP_BASE_URL}/api/product/active/get`
// Product with sub products
const GET_ALL_PRODUCTS =  `${APP_BASE_URL}api/product/all/get`

// CATEGORY
const ADD_PRODUCT_CATEGORY = `${APP_BASE_URL}api/product/category`
const GET_PRODUCT_CATEGORY = `${APP_BASE_URL}api/product/category/fetch`

// SUB CATEGORY
const ADD_PRODUCT_SUB_CATEGORY = `${APP_BASE_URL}api/product/sub-category`
const GET_PRODUCT_SUB_CATEGORY = `${APP_BASE_URL}api/product/sub-category/fetch`

// PRODUCT TYPE
const ADD_PRODUCT_TYPE = `${APP_BASE_URL}apI/product/type`
const GET_PRODUCT_TYPE = `${APP_BASE_URL}api/product/types/fetch`

// PRODUCT SERIES
const ADD_PRODUCT_SERIES = `${APP_BASE_URL}api/product/series`
const GET_PRODUCT_SERIES = `${APP_BASE_URL}api/product/series/fetch`

// PRODUCT SUB SERIES
const ADD_PRODUCT_SUB_SERIES = `${APP_BASE_URL}api/product/sub-series`
const GET_PRODUCT_SUB_SERIES = `${APP_BASE_URL}api/product/sub-series/fetch`

// #CUSTOMER
const ADD_CUSTOMER_EDIT_CUSTOMER = `${APP_BASE_URL}api/customer`
const GET_ALL_CUSTOMER = `${APP_BASE_URL}api/customer/fetch`
const CHANGE_CUSTOMER_STATUS = `${APP_BASE_URL}api/customer/status`
const SINGLE_CUSTOMER_DETAILS =  `${APP_BASE_URL}api/customer/details/fetch`
const GET_ALL_ACTIVE_CUSTOMER =  `${APP_BASE_URL}api/customer/active/get`

// #SALES PERSON
const GET_ALL_ACTIVE_SALES_PERSON =  `${APP_BASE_URL}api/user/sales/active/get` 

// #USER
const ADD_USER_EDIT_USER = `${APP_BASE_URL}api/user`
const GET_ALL_USERS = `${APP_BASE_URL}api/user/fetch`
const CHANGE_USER_STATUS = `${APP_BASE_URL}api/user/status`
const GET_SINGLE_USER_DETAILS  = `${APP_BASE_URL}api/user/details/fetch`

const GET_ALL_ROLES = `${APP_BASE_URL}api/roles/fetch`
// #PDF
const DOWNLOAD_PDF = `${APP_BASE_URL}api/quotation/download`

// #DISTRIBUTOR
const ADD_DISTRIBUTOR_EDIT_DISTRIBUTOR = `${APP_BASE_URL}api/distributor`
const GET_ALL_DISTRIBUTOR = `${APP_BASE_URL}api/distributor/fetch`
const CHANGE_DISTRIBUTOR_STATUS = `${APP_BASE_URL}api/distributor/status`
const GET_ACTIVE_DISTRIBUTORS =  `${APP_BASE_URL}api/distributor/active/get`
const GET_SINGLE_DISTRIBUTOR_DETAILS  = `${APP_BASE_URL}api/distributor/details/fetch`

// #TAXATIONS
const ADD_TAXATION_EDIT_TAXATION = `${APP_BASE_URL}api/tax`
const GET_ALL_TAXATION = `${APP_BASE_URL}api/taxations/fetch`
const CHANGE_TAXATIONS_STATUS = `${APP_BASE_URL}api/taxation/status`
const GET_SINGLE_TAXATIONS_DETAILS  = `${APP_BASE_URL}api/taxation/details/fetch`
const GET_ALL_ACTIVE_TAXATION = `${APP_BASE_URL}api/taxation/active/fetch`

// #MANUFACTURE
const ADD_VENDOR = `${APP_BASE_URL}api/manufacturer`
const GET_ALL_VENDORS = `${APP_BASE_URL}api/manufacturer/fetch`
const CHANGE_VENDOR_STATUS = `${APP_BASE_URL}api/manufacturer/status`
const GET_VENDOR_RELATE_DETAILS = `${APP_BASE_URL}api/manufacturer/distributors`
const GET_ACTIVE_VENDORS = `${APP_BASE_URL}api/manufacturer/active/get`

// #CERTIFICATION
const GET_ALL_CERTIFICATED_PRODUCTS =  `${APP_BASE_URL}api/certificate/product/get`
const GET_ALL_CERTIFICATIONS =  `${APP_BASE_URL}api/certificate/fetch`
const ADD_CERTIFICATE =  `${APP_BASE_URL}api/certificate/add`
const ADD_ASSIGN_CERTIFICATED_PRODUCTS =  `${APP_BASE_URL}api/certificate/product/assign`
const GET_SINGLE_PRODUCT_CERTIFICATE_DETAILS =  `${APP_BASE_URL}api/certificate/product/details/fetch`

// #APPLICATION SETTINGS
const ADD_APP_SETTINGS_EDIT_APP_SETTINGS = `${APP_BASE_URL}api/settings`
const GET_APP_SETTINGS_DETAILS = `${APP_BASE_URL}api/settings/details/fetch`
const GET_APP_SETTINGS_COUNTRY_SPECIFIC_TAX_DETAILS = `${APP_BASE_URL}api/settings/country/tax/details/fetch`


// TERMS AND CONDITION
const ADD_TERMS_AND_CONDITION = `${APP_BASE_URL}api/terms-condition`
const DELETE_TERMS_AND_CONDITION = `${APP_BASE_URL}api/terms-condition/remove`
const GET_ALL_TERMS_AND_CONDITION = `${APP_BASE_URL}api/terms-condition/fetch`

// QUOTATION
const ADD_QUOTATION = `${APP_BASE_URL}api/quotation`
const GET_QUOTATION = `${APP_BASE_URL}api/quotation/fetch`
const GET_SINGLE_QUOTATION = `${APP_BASE_URL}api/quotation`


// PRICING POLICY
const GET_PRICING_POLICY = `${APP_BASE_URL}api/pricing-policy/fetch`

module.exports = {
    LOGIN,
    ADD_PRODUCT,
    GET_ALL_PRODUCT,
    ADD_SUB_PRODUCT,
    GET_ALL_SUB_PRODUCT,
    GET_ALL_ACTIVE_PRODUCTS_OR_SUB_PRODUCTS,
    GET_PRODUCT_RELATE_SUB_PRODUCTS,
    ADD_PRODUCT_CATEGORY, //CATEGORY
    GET_PRODUCT_CATEGORY,
    ADD_PRODUCT_SUB_CATEGORY, //SUB CATEGORY
    GET_PRODUCT_SUB_CATEGORY,
    ADD_PRODUCT_TYPE, // PRODUCT TYPE
    GET_PRODUCT_TYPE,
    ADD_PRODUCT_SERIES, //SERIES
    GET_PRODUCT_SERIES,
    ADD_PRODUCT_SUB_SERIES,// SUB SERIES
    GET_PRODUCT_SUB_SERIES,
    ADD_CUSTOMER_EDIT_CUSTOMER,
    GET_ALL_CUSTOMER,
    GET_ALL_ACTIVE_CUSTOMER,
    GET_ALL_ACTIVE_SALES_PERSON, // SALES PERSON
    GET_ALL_USERS,
    GET_ALL_ROLES,
    CHANGE_PRODUCT_STATUS,
    CHANGE_SUB_PRODUCT_STATUS,
    CHANGE_CUSTOMER_STATUS,
    CHANGE_USER_STATUS,
    GET_ACTIVE_PRODUCTS,
    DOWNLOAD_PDF,
    ADD_DISTRIBUTOR_EDIT_DISTRIBUTOR,
    GET_ALL_DISTRIBUTOR,
    CHANGE_DISTRIBUTOR_STATUS,
    GET_ACTIVE_DISTRIBUTORS,
    ADD_VENDOR,
    GET_ALL_VENDORS,
    CHANGE_VENDOR_STATUS,
    GET_VENDOR_RELATE_DETAILS,
    GET_ACTIVE_VENDORS,
    GET_SINGLE_PRODUCT_DETAILS,
    GET_ALL_CERTIFICATED_PRODUCTS,
    GET_ALL_CERTIFICATIONS,
    ADD_CERTIFICATE,
    GET_ALL_PRODUCTS,
    ADD_ASSIGN_CERTIFICATED_PRODUCTS,
    GET_SINGLE_PRODUCT_CERTIFICATE_DETAILS,
    GET_SINGLE_USER_DETAILS,
    ADD_USER_EDIT_USER,
    SINGLE_CUSTOMER_DETAILS,
    GET_SINGLE_DISTRIBUTOR_DETAILS,
    ADD_TAXATION_EDIT_TAXATION,//TAXATION
    GET_ALL_TAXATION,
    CHANGE_TAXATIONS_STATUS,
    GET_SINGLE_TAXATIONS_DETAILS,
    GET_ALL_ACTIVE_TAXATION,
    ADD_APP_SETTINGS_EDIT_APP_SETTINGS,//SETTINGS
    GET_APP_SETTINGS_DETAILS,
    GET_APP_SETTINGS_COUNTRY_SPECIFIC_TAX_DETAILS,
    PRODUCT_RELATED_DETAILS,
    ADD_TERMS_AND_CONDITION, //TERMS AND CONDITION
    DELETE_TERMS_AND_CONDITION,
    GET_ALL_TERMS_AND_CONDITION,
    ADD_QUOTATION, // QUOTATION
    GET_QUOTATION,
    GET_SINGLE_QUOTATION,
    GET_PRICING_POLICY, // PRICING POLICY
    DASHBOARD_FETCH // DASHBOARD
}